import { postApi } from "../../../shared/api/postApi"
import type { ListarAuditoriaRequest, ListarAuditoriaResult } from "../types/auditoria.types"

// Contrato preservado: { status, resultado, message } | undefined
export const listarAuditoria = (dataPOST: ListarAuditoriaRequest): Promise<ListarAuditoriaResult | undefined> =>
    postApi("api/auditoria/listar_auditoria", dataPOST, (d) => ({ resultado: d.resultado }), { resultado: "" })
